export default __webpack_public_path__ + "static/logo_shopify-1bbf3574a33072a08f8dbd958ee7f4b5.jpg";